/*
This action file conatin the action related to user, like authenticate, add user,delete user etc
*/
import * as api from '../api';

export const AUTHENTICATE_REQUEST = 'AUTHENTICATE_REQUEST';
export const AUTHENTICATE_FAILURE = 'AUTHENTICATE_FAILURE';
export const AUTHENTICATE_SUCCESS = 'AUTHENTICATE_SUCCESS';
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';

export const authenticate = (username, password) => {
  return (dispatch, getState) => {
    dispatch({
      type: AUTHENTICATE_REQUEST
    });

    api.authenticate(username, password).then(
      (response) => {
        if( response.token) {
          dispatch({
            type: AUTHENTICATE_SUCCESS,
            token: response.token,
            username: response.username,
            usertype: response.userType
          });
        } else {
          dispatch({
            type: AUTHENTICATE_FAILURE,
            error: response.error
          });
          dispatch({
            type: NOTIFICATION_ADD,
            text: response.error || response.message,
            time: Date.now(),
            msgtype: 'danger'
          });
          dispatch({
            type: ADD_COMPANY_SUCCESS,
            users: response.finalData,
            redirecturl: response.redirectUrl
          });
        }

      },
      (error) => {
        dispatch({
          type: AUTHENTICATE_FAILURE,
          error: error
        });
      }
    );
  };
};
export const FORGET_POPUP_RESET = 'FORGET_POPUP_RESET';
export function resetForgetPopup(){
  return function(dispatch, getState){
      dispatch({
        type: FORGET_POPUP_RESET
      });
  };
}
export const AUTHENTICATE_EMAIL_REQUEST = 'AUTHENTICATE_EMAIL_REQUEST';
export const AUTHENTICATE_EMAIL_FAILURE = 'AUTHENTICATE_EMAIL_FAILURE';
export const AUTHENTICATE_EMAIL_SUCCESS = 'AUTHENTICATE_EMAIL_SUCCESS';
export const authenticateUserEmail= (username) => {
  return (dispatch, getState) => {
    dispatch({
      type: AUTHENTICATE_EMAIL_REQUEST
    });

    api.authenticateUserEmail(username).then(
      (response) => {
        if( response.username ) {
          dispatch({
            type: AUTHENTICATE_EMAIL_SUCCESS,
            username: response.username
          });
        } else {
          dispatch({
            type: NOTIFICATION_ADD,
            text: response.error,
            time: Date.now(),
            msgtype: 'danger'
          });
        }

      },
      (error) => {
        dispatch({
          type: AUTHENTICATE_EMAIL_FAILURE,
          error: error
        });
      }
    );
  };
};

export const USERS_FETCH_REQUEST = 'USERS_FETCH_REQUEST';
export const USERS_FETCH_FAILURE = 'USERS_FETCH_FAILURE';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';

export const fetchUsers = () => {
  return (dispatch, getState) => {
    dispatch({
      type: USERS_FETCH_REQUEST
    });

    api.fetchUsers().then(
      (response) => {
        dispatch({
          type: USERS_FETCH_SUCCESS,
          users: response
        });
      },
      (error) => {
        dispatch({
          type: USERS_FETCH_FAILURE,
          error: error,
          message: error.message || 'Could not fetch users'
        });
      }
    );
  };
};


export const USERS_ADD_REQUEST = 'USERS_ADD_REQUEST';
export const USERS_ADD_FAILURE = 'USERS_ADD_FAILURE';
export const USERS_ADD_SUCCESS = 'USERS_ADD_SUCCESS';

export const addUser = (username, password) => {
  return (dispatch, getState) => {
    dispatch({
      type: USERS_ADD_REQUEST
    });

    api.addUser(username, password).then(
      (response) => {
        dispatch({
          type: USERS_ADD_SUCCESS,
          users: response // TODO: Should the list of users be returned?
        });
      },
      (error) => {
        error.then(function(e) {
          dispatch({
            type: USERS_ADD_FAILURE,
            error: e.error,
            message: e.error.message || 'Could not add user'
          });
        });
      }
    );
  };
};

export const USERS_UPDATE_PASSWORD_REQUEST = 'USERS_UPDATE_PASSWORD_REQUEST';
export const USERS_UPDATE_PASSWORD_SUCCESS = 'USERS_UPDATE_PASSWORD_SUCCESS';
export const USERS_UPDATE_PASSWORD_FAILURE = 'USERS_UPDATE_PASSWORD_FAILURE';

export const updatePassword = (userId, password) => {
  return (dispatch, getState) => {
    dispatch({
      type: USERS_UPDATE_PASSWORD_REQUEST
    });

    api.updatePassword(userId, password).then(
      (response) => {
        dispatch({
          type: USERS_UPDATE_PASSWORD_SUCCESS,
        });
        dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'Password updated'
        });
      },
      (error) => {
        dispatch({
          type: USERS_UPDATE_PASSWORD_FAILURE,
          error: error,
          message: error.message || 'Could not update password'
        });
      }
    );
  };
};

export const USERS_DELETE_REQUEST = 'USERS_DELETE_REQUEST';
export const USERS_DELETE_SUCCESS = 'USERS_DELETE_SUCCESS';
export const USERS_DELETE_FAILURE = 'USERS_DELETE_FAILURE';

export const deleteUser = (userId) => {
  return (dispatch, getState) => {
    dispatch({
      type: USERS_DELETE_REQUEST
    });

    api.deleteUser(userId).then(
      (response) => {
        dispatch({
          type: USERS_DELETE_SUCCESS,
        });
        dispatch({
          type: 'Add Edit Delete TeamMember',
        });
        dispatch({
          type: NOTIFICATION_ADD,
          text: 'Team Member deleted successfully.',
          msgtype: 'success'
        });
      },
      (error) => {
        dispatch({
          type: USERS_DELETE_FAILURE,
          error: error,
          message: error.message || 'Could not delete'
        });
        dispatch({
            type: NOTIFICATION_ADD,
            text: 'Could not complete delete member request.',
            msgtype: 'danger'
          });
      }
    );
  };
};

export const CURRENT_USER_FETCH_REQUEST = 'CURRENT_USER_FETCH_REQUEST';
export const CURRENT_USER_FETCH_FAILURE = 'CURRENT_USER_FETCH_FAILURE';
export const CURRENT_USER_FETCH_SUCCESS = 'CURRENT_USER_FETCH_SUCCESS';

export const fetchLoginUserDetail = (pageNumber) => {
  return (dispatch, getState) => {
    dispatch({
      type: CURRENT_USER_FETCH_REQUEST
    });

    api.fetchLoginUserDetail(pageNumber).then(
      (response) => {
        // console.log("response====>",response)
        dispatch({
          type: CURRENT_USER_FETCH_SUCCESS,
          user: response.userdetail,
          company: response.company,
          subsuser: response.subsdetail,
          companydetail: response.companydetail,
          companymembers: response.companymembers,
          subscriptions: response.subscriptions,
          alljobs: response.alljobs,
          companyjobs: response.companyjobs,
          stats: response.stats,
          tokenStatus: response.tokenStatus,
          companyData: response.companyData, // use in case simpro token expires
          adminData: response.adminDetail,
          subscription_history: response.Subscriptionhistory,
          SubscriptionActive: response.SubscriptionActive,
          allusers: response.allUsers,
          count: response.count,
        });
      },
      (error) => {
        dispatch({
          type: CURRENT_USER_FETCH_FAILURE,
          error: error,
          message: error.message || 'Could not fetch user'
        });
      }
    );
  };
};

export const SEND_FORGAT_PASS_EMAIL_REQUEST='SEND_FORGAT_PASS_EMAIL_REQUEST'
export const SEND_FORGAT_PASS_EMAIL_SUCCESS='SEND_FORGAT_PASS_EMAIL_SUCCESS'

export const sendForgatPassEmail =(username) => {
  return function (dispatch, getState) {
    dispatch({
      type: SEND_FORGAT_PASS_EMAIL_REQUEST
    });
    api.sendForgatPassEmail(username).then(
      (response) => {
        dispatch({
          type: SEND_FORGAT_PASS_EMAIL_SUCCESS
        });
      }
    );
  };
}

export const getLoggedInUser =() => {
  return function (dispatch, getState) {
    dispatch({
      type: 'GET_LOGGEDIN_USER_REQUEST'
    });
    return api.getLoggedInUser().then(
      (response) => {
        dispatch({
          type: 'GET_LOGGEDIN_USER_REQUEST_SUCCESS',
          loggeInUser : response
        });
      },
      (error) => {
        dispatch({
          type: 'GET_LOGGEDIN_USER_REQUEST_FAILURE'
        });
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/Actions/users.js